import { appSliceActions } from "./appSlice"

export const appActions = {
    ...appSliceActions
}
